import api from "../../../services/api";

export const getWorkDashboard = () =>
  api.get("/work/dashboard");

export const getAssignmentCycles = () =>
  api.get("/work/assignment-cycles");

export const openWorkFromCycle = (cycleId) =>
  api.post(`/work/open-cycle/${cycleId}`);

export const getWorks = () =>
  api.get("/work/list");

export const getWorkEngagementDetail = (id) =>
  api.get(`/work/assignment/${id}`);

export const getAssignments = () =>
  api.get("/assignments/list");

export const getWorkAreas = (workId) =>
  api.get(`/work-areas/${workId}`);

export const createWorkArea = (data) =>
  api.post(`/work-areas`, data);

export const getTasksByArea = (areaId) =>
  api.get(`/work-tasks/by-area/${areaId}`);

export const startCycle = (cycleId) =>
  api.post(`/work/start-cycle/${cycleId}`);

export const createTask = (data) =>
  api.post("/work-tasks", data);

export const getChecklistByTask = (taskId) =>
  api.get(`/work-checklist/by-task/${taskId}`);

export const createChecklistItem = (data) =>
  api.post("/work-checklist", data);

export const updateChecklistStatus = (id, status) =>
  api.put(`/work-checklist/${id}/status`, { status });